import { Routes } from '@angular/router';

import { LandingPage } from './pages/landing/landing.page';
import { NotFoundPage } from './pages/not-found/not-found.page';
import { AuthCallbackPage } from './pages/auth-callback/auth-callback.page';
import { WorkspaceShellComponent } from './pages/workspace-shell/workspace-shell.component';
import { WorkspaceHomePage } from './pages/workspace-home/workspace-home.page';
import { AdminAccessRequestsPage } from './pages/admin-access-requests/admin-access-requests.page';
import { AdminUsersPage } from './pages/admin-users/admin-users.page';
import { AdminItemTypesPage } from './pages/admin-item-types/admin-item-types.page';
import { AdminPointOfInterestTypesPage } from './pages/admin-point-of-interest-types/admin-point-of-interest-types.page';
import { AdminWorldUsersPage } from './pages/admin-world-users/admin-world-users.page';
import { WorldShellPage } from './pages/world-shell/world-shell.page';
import { WorldOverviewPage } from './pages/world-overview/world-overview.page';
import { WorldCreatePage } from './pages/world-create/world-create.page';
import { EntityListPage } from './pages/entity-list/entity-list.page';
import { EntityEditorPage } from './pages/entity-editor/entity-editor.page';
import { MediaLibraryPage } from './pages/media-library/media-library.page';

import { authGuard } from './auth/auth.guard';
import { AdminGuard } from './auth/admin.guard';
import { ApprovalGuard } from './auth/approval.guard';

export const routes: Routes = [
	{ path: '', component: LandingPage },
	{ path: 'auth/callback', component: AuthCallbackPage },
	{
		path: 'workspace',
		component: WorkspaceShellComponent,
		canActivate: [authGuard],
		children: [
			{ path: '', component: WorkspaceHomePage },
			{
				path: 'admin/access-requests',
				component: AdminAccessRequestsPage,
				canActivate: [authGuard, AdminGuard],
			},
			{
				path: 'admin/users',
				component: AdminUsersPage,
				canActivate: [authGuard, AdminGuard],
			},
			{
				path: 'admin/world-users',
				component: AdminWorldUsersPage,
				canActivate: [authGuard, AdminGuard],
			},
			{
				path: 'admin/item-types',
				component: AdminItemTypesPage,
				canActivate: [authGuard, AdminGuard],
			},
			{
				path: 'admin/point-of-interest-types',
				component: AdminPointOfInterestTypesPage,
				canActivate: [authGuard, AdminGuard],
			},
			{
				path: 'worlds/new',
				component: WorldCreatePage,
				canActivate: [authGuard, ApprovalGuard],
			},
			{
				path: 'worlds/:worldId',
				component: WorldShellPage,
				canActivate: [authGuard, ApprovalGuard],
				children: [
					{ path: '', component: WorldOverviewPage },
					{ path: 'media', component: MediaLibraryPage },
					// Entity-specific routes (refactored)
					{
						path: 'regions',
						loadChildren: () => import('./pages/regions/region.routes').then((m) => m.REGION_ROUTES),
					},
					{
						path: 'points-of-interest',
						loadChildren: () => import('./pages/points-of-interest/poi.routes').then((m) => m.POI_ROUTES),
					},
					{
						path: 'non-player-characters',
						loadChildren: () => import('./pages/non-player-characters/npc.routes').then((m) => m.NPC_ROUTES),
					},
					{
						path: 'player-characters',
						loadChildren: () => import('./pages/player-characters/pc.routes').then((m) => m.PC_ROUTES),
					},
					{
						path: 'factions',
						loadChildren: () => import('./pages/factions/faction.routes').then((m) => m.FACTION_ROUTES),
					},
					{
						path: 'pantheons',
						loadChildren: () => import('./pages/pantheons/pantheon.routes').then((m) => m.PANTHEON_ROUTES),
					},
					{
						path: 'gods',
						loadChildren: () => import('./pages/gods/god.routes').then((m) => m.GOD_ROUTES),
					},
					{
						path: 'domains',
						loadChildren: () => import('./pages/domains/domain.routes').then((m) => m.DOMAIN_ROUTES),
					},
					{
						path: 'encounters',
						loadChildren: () => import('./pages/encounters/encounter.routes').then((m) => m.ENCOUNTER_ROUTES),
					},
					{
						path: 'items',
						loadChildren: () => import('./pages/items/item.routes').then((m) => m.ITEM_ROUTES),
					},
					{
						path: 'merchants',
						loadChildren: () => import('./pages/merchants/merchant.routes').then((m) => m.MERCHANT_ROUTES),
					},
					{
						path: 'tomes',
						loadChildren: () => import('./pages/tomes/tome.routes').then((m) => m.TOME_ROUTES),
					},
					// Legacy generic routes (will be replaced as entities are refactored)
					{
						path: ':entity',
						component: EntityListPage,
					},
					{
						path: ':entity/new',
						component: EntityEditorPage,
					},
					{
						path: ':entity/:id',
						component: EntityEditorPage,
					},
				],
			},
			{ path: '**', component: NotFoundPage },
		],
	},
	{ path: '**', component: NotFoundPage },
];
